module.exports = __webpack_public_path__ + "img/template-example.ee424716.jpg";